// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1DIc4","head":"Table_head__3Po7B","col":"Table_col__VhgsR"};